import type Feature from 'ol/Feature'
import type Geometry from 'ol/geom/Geometry'
import type { OptionalSelectionModifiers } from '@/atoms'

import { getCrudSelection, setCrudSelection, getMainSelection, setMainSelection } from '@/atoms'

import { getConnectedList } from '../../../../atoms/selection/read/getConnectedList'
import { getMapSelectionContext } from '../../../../atoms/selection/read/getMapSelectionContext'

export function clickPlace(feature: Feature<Geometry>, modifiers: OptionalSelectionModifiers) {
  const connectedList = getConnectedList()
  const mapSelectionContext = getMapSelectionContext()

  const placeId = feature.getId()?.toString()

  if (placeId) {
    const selection = [placeId]

    // select
    if (mapSelectionContext.type === 'crud') {
      if (mapSelectionContext.category === 'places') {
        const crudSelection = getCrudSelection()
        const withoutModifiers = Object.keys(modifiers).every(key => modifiers[key] === false)

        // If there's no modifier and the place is already selected we must deselect it
        if (withoutModifiers) {
          const index = crudSelection.places.indexOf(selection[0])

          if (index !== -1) {
            selection.splice(index, 1)

            setCrudSelection('places', selection, { modifiers })
            return
          }
        }

        setCrudSelection('places', selection, { modifiers })

        // try to scroll to
        if (
          connectedList.status === 'connected' &&
          connectedList.category === 'places' &&
          !connectedList.disabled
        ) {
          connectedList.scrollTo(placeId)
        }
      }
    } else {
      const mainSelection = getMainSelection()
      const withoutModifiers = Object.keys(modifiers).every(key => modifiers[key] === false)

      // If there's no modifier and the place is already selected we must deselect it
      if (withoutModifiers) {
        const index = mainSelection.places.indexOf(selection[0])

        if (index !== -1) {
          selection.splice(index, 1)

          setMainSelection('places', selection, { modifiers })
          return
        }
      }
      setMainSelection('places', selection, { modifiers })
    }
  }
}
